module.exports = __webpack_public_path__ + "static/titivilus-26ef9f7c780d57142e22904756ce07c0.png";